import { mimeTypeIcon } from "../../../../../constants";
const { ListItem, ListItemText, Divider, ListItemAvatar, withStyles } = window.Material;
import { Item } from '../../../../../types/types';
import { ContentContext } from "../../../../../utils/contexts";

const styles = {
  avatar: {
    fontSize: '22px',
    minWidth: 'auto',
    marginRight: '10px',
    color: '#8e8e8e',
    '& .green': {
      color: 'green',
    },
    '& .red': {
      color: 'red',
    },
    '& .blue': {
      color: '#0e1f3e',
    },
  },
  divider: {
    margin: '0 !important',
  },
  item: {
    paddingLeft: '16px !important',
    paddingTop: '0',
    paddingBottom: '0',
  },
  text: {
    fontSize: '13px',
    wordBreak: 'break-all',
  },
};

interface SearchItemProps {
  item: Item;
  classes: any;
}

class SearchItem extends window.React.PureComponent<SearchItemProps> {
  onItemSelect = (item: Item) => {
    const { onItemSelect } = this.context;

    onItemSelect(item);
  };

  // onLinkClick = (event: React.MouseEvent, item: Item) => {
  //   event && event.preventDefault();
  //   event.stopPropagation();
  //
  //   const { onFolderOpen } = this.context;
  //
  //   onFolderOpen(item);
  // };

  render() {
    const { item, classes } = this.props;
    const { selected, hidden, loadingContent } = this.context;

    const isSelected = Boolean(selected[item.nodeRef]);
    const isHidden = Boolean(hidden[item.nodeRef]);

    const fileIconClass = mimeTypeIcon[item.mimetype];

    return (
      <React.Fragment>
        <ListItem
          disableRipple
          disableTouchRipple
          button
          key={item.nodeRef}
          onClick={() => this.onItemSelect(item)}
          selected={isSelected}
          disabled={item.disabled || isHidden || loadingContent}
          classes={{ root: classes.item }}
        >
          <ListItemAvatar classes={{ root: classes.avatar }}>
            <i className={`fas fa-${isSelected ? 'check-circle blue' : fileIconClass}`} />
          </ListItemAvatar>
          <ListItemText
            classes={{ primary: classes.text, secondary: classes.text }}
            primary={item.name}
            secondary={
              item.path
                ? item.path.every(pathEl => pathEl.name === '')
                ? ''
                : item.path.map(pathEl => pathEl.name || pathEl).join('/')
                : null
            }
          />
        </ListItem>
        <Divider classes={{ root: classes.divider }} />
      </React.Fragment>
    );
  }
}

SearchItem.contextType = ContentContext;

export default withStyles(styles)(SearchItem);
